import IntlMessages from "../../../../util/IntlMessages";
import Checkbox from "../../../BP2Components/Checkbox";
import { Input } from "../../../BP2Components";
import React from "react";
import { tDevForm } from "../../RenderDevEditForm";
import "./ListSettings.less";
import "../../RenderDevEditForm.less";

const ListSettings = ({ state, setField }: tDevForm) => {
   return (
      <div className="dev-select-settings">
         <div className="section-title">
            <IntlMessages id="devForm.pickListSettings" />
         </div>

         <div className="dev-select-settings__group dev-form-group-vertical-12">
            <div className="dev-form-row dev-form-row-gap-12">
               <label className="dev-label-nowrap">
                  <IntlMessages id="devForm.showEmptyOptionInPickList" />:
               </label>
               <Checkbox
                  checked={!!state.dropdownIsEmptyOption}
                  onChange={(e) => setField?.("dropdownIsEmptyOption", Number(e.target.checked))}
               />
            </div>

            <div className="dev-form-row dev-form-row-gap-12 dev-full-width">
               <label className="dev-label-nowrap">
                  <IntlMessages id="devForm.emptyOptionLabel" />:
               </label>
               <Input
                  type="text"
                  value={state.dropdownEmptyOptionLabel}
                  onChange={(e) => setField?.("dropdownEmptyOptionLabel", e.target.value)}
                  disabled={!state.dropdownIsEmptyOption}
                  placeholder=""
               />
            </div>

            <div className="dev-form-row dev-form-row-gap-12 dev-full-width">
               <label className="dev-label-nowrap">
                  <IntlMessages id="devForm.emptyOptionValue" />:
               </label>
               <Input
                  type="text"
                  value={state.dropdownEmptyOptionValue}
                  onChange={(e) => setField?.("dropdownEmptyOptionValue", e.target.value)}
                  disabled={!state.dropdownIsEmptyOption}
                  placeholder=""
               />
            </div>
         </div>
      </div>
   );
};

export default ListSettings;
